import React from "react";

import App from "./App";
import * as serviceWorker from "./serviceWorker";

import AuthBootstrap from "./AuthBootstrap";

//style imports
import GlobalStyles from "./styles/globalStyles";
import "./styles/tailwind.css";

//contexts
import { UserProvider } from "./context/user-context";
import { QuestionVariablesProvider } from "./pages/admin/admin-context";

import { hydrate, render } from "react-dom";
import history from "./history";
import { initFacebookPixel, trackPageView } from "./analytics/facebookPixel";

const rootElement = document.getElementById("root");

// Defer Meta Pixel until after page load to avoid blocking LCP
function startPixel() {
  initFacebookPixel("2349233825508057");
  trackPageView();
  history.listen(() => {
    trackPageView();
  });
}
if (typeof window !== "undefined") {
  setTimeout(startPixel, 5000);
}

if (rootElement?.hasChildNodes()) {
  hydrate(
    <QuestionVariablesProvider>
      <UserProvider>
        <AuthBootstrap>
          <GlobalStyles />
          <App />
        </AuthBootstrap>
      </UserProvider>
    </QuestionVariablesProvider>,
    rootElement
  );
} else {
  render(
    <QuestionVariablesProvider>
      <UserProvider>
        <AuthBootstrap>
          <GlobalStyles />
          <App />
        </AuthBootstrap>
      </UserProvider>
    </QuestionVariablesProvider>,
    rootElement
  );
}

// ReactDOM.render(
//   <QuestionVariablesProvider>
//     <UserProvider>
//       <CustomProvider>
//         <GlobalStyles />
//         <App />
//       </CustomProvider>
//     </UserProvider>
//   </QuestionVariablesProvider>,
//   rootElement
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
